import { UnstyledButton } from '@mantine/core';
import { Icon } from '@blueprintjs/core';
import { Text } from '@components/index';
import { ShortcutRefs, shortcuts } from './Shortcuts.utils';
import { StyledDiv } from './Shortcuts.styles';

interface ShortcutsProps {
  shortcutRefs: React.MutableRefObject<ShortcutRefs>;
  className?: string;
}
function Shortcuts(props: ShortcutsProps) {
  const { shortcutRefs, ...rest } = props;
  return (
    <StyledDiv {...rest}>
      <div className="Shortcuts_list reset-global new-icon">
        {shortcuts.map(shortcut => {
          const onshortcutClick = () => {
            const el = shortcutRefs.current[shortcut.hash];
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          };
          return (
            <UnstyledButton
              key={shortcut.hash}
              onClick={onshortcutClick}
              // href={`#${shortcut.hash}`} Maybe someday
              className="Shortcuts_list_item"
            >
              <Icon icon={shortcut.icon} />
              <Text
                text="h300"
                textColor="n600"
                className="Shortcuts_list_item_label"
              >
                {shortcut.label}
              </Text>
            </UnstyledButton>
          );
        })}
      </div>
    </StyledDiv>
  );
}

export default Shortcuts;
